export const DEFAULT_API_KEY_MASKING_VALUE = '******';
